/**
 * /igaming-multi-level — primary-slug route file for Feature #156.
 *
 * This file exists so the dash contract (D1) can resolve
 * `routes/igaming-multi-level.tsx` for slug `igaming-multi-level`. The
 * existing namespaced route in `igaming.multi-level.tsx` holds the real
 * breadcrumb wrapper + page; we re-export both the route constant and the
 * component so either import path works.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { IgamingMultiLevelPage } from "@/features/igaming-multi-level/IgamingMultiLevelPage";

export const igamingMultiLevelRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-multi-level",
	component: IgamingMultiLevelPage,
});

export default igamingMultiLevelRoute;
